import styled from 'styled-components/macro';
import { ToastContainer } from 'react-toastify';
import { colorShade, whiteColor } from '@twnel/web-components';

const StyledToast = styled(ToastContainer)`
  .Toastify__toast {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    font-size: .9rem;
    font-family: 'Quicksand', sans-serif;
    font-weight: 500;

    &.Toastify__toast--default,
    &.Toastify__toast--success,
    &.Toastify__toast--error,
    &.Toastify__toast--info,
    &.Toastify__toast--warning {
      background: ${({ theme }) => theme.background};
      color: ${({ theme }) => theme.foreground};

      .Toastify__progress-bar--default {
        background: linear-gradient(90deg,
          ${({ theme }) => colorShade(5, theme.actionable)},
          ${({ theme }) => colorShade(5, theme.actionable)},
          ${({ theme }) => colorShade(9, theme.actionable)}
        );
      }

      .Toastify__progress-bar--success {
        background: linear-gradient(90deg,
          ${({ theme }) => theme.success},
          ${({ theme }) => theme.success},
          ${({ theme }) => whiteColor(3, theme.success)}
        );
      }

      .Toastify__progress-bar--error {
        background: linear-gradient(90deg,
          ${({ theme }) => theme.error},
          ${({ theme }) => theme.error},
          ${({ theme }) => whiteColor(3, theme.error)}
        );
      }

      .Toastify__progress-bar--info {
        background: linear-gradient(90deg,
          ${({ theme }) => theme.brandAccent},
          ${({ theme }) => theme.brandAccent},
          ${({ theme }) => whiteColor(3, theme.brandAccent)}
        );
      }

      .Toastify__progress-bar--warning {
        background: linear-gradient(90deg,
          ${({ theme }) => theme.warning},
          ${({ theme }) => theme.warning},
          ${({ theme }) => whiteColor(3, theme.warning)}
        );
      }
    }
  }
`;

export default StyledToast;
